module.exports = __webpack_public_path__ + "img/pic24.362b9c74.png";